"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parsePaths = void 0;
var _array = require("../type-checks/array");
var _string = require("../type-checks/string");
const merge = require("deepmerge");

/**
 * Parses path from sequential array of string elements, used by Breadcrumb component
 *
 * @name parsePaths
 * @param {array} elementArray Path saved as an array of strings
 * @param {string} prefix Prefix to prepend to the given path
 * @returns {object} Object containing parsed label and path
 */
const parsePaths = (elementArray, prefix) => {
  let pathObject = {};
  const workingPrefix = (0, _string.isStringOfLength)(prefix) ? prefix : "";
  elementArray.forEach(obj => {
    let workingLabel = "";
    if ((0, _string.isStringOfLength)(obj.path) && obj.path !== "*" && obj.path !== "/") {
      if ((0, _string.isStringOfLength)(obj.label)) {
        workingLabel = obj.label;
      } else {
        workingLabel = obj.path;
      }
      pathObject[workingPrefix + "/" + obj.path] = workingLabel;
      if ((0, _array.isArrayOfLength)(obj.children)) {
        pathObject = merge(pathObject, parsePaths(obj.children, workingPrefix + "/" + obj.path));
      }
    } else if (obj.index || (0, _string.isStringOfLength)(obj.path) && obj.path === "/" && (0, _string.isStringOfLength)(obj.label)) {
      pathObject[workingPrefix + "/"] = obj.label;
    }
  });
  return pathObject;
};
exports.parsePaths = parsePaths;